<template>
<div class="project-background">
  <!-- <PremiumCard v-if="showPremiumScreen" :project="project" /> -->
  <GuestModal v-if="showGuestModal" @closeModal="isGuestModalOpen = false" />
  <div class="header-image" :style="{ backgroundImage: `url(${project.mainImageUrl})`}"></div>
  <div class="info-wrapper">
    <div class="info-container">
      <div class="main-container">
        <gallery :images="project.mediaGallery" />
      </div>
      <div class="side-container">
        <div class="project-name">{{ project.name }}</div>
        <div class="project-location">{{ project.location }}</div>
        <div class="time-section">
          <div class="time"><span>{{ formatPercentage(project.salesPercentage) }}%</span> de las ventas</div>
          <div class="time" v-if="project.totalMonthPayments">durante <span>{{ project.totalMonthPayments / 12 }}</span> años</div>
          <div class="time" v-else style="margin-top: 8px">permanentemente</div>
        </div>
        <progress-chart class="progress-wrapper" :current="project.raised" :minTarget="project.minTarget" :maxTarget="project.maxTarget" />
        <div class="stats">
          <div class="stat-money">
            <div class="stat-value">{{ formatMoney(project.raised) }}</div>
            <div class="stat-title">Recaudado</div>
          </div>
          <div class="stat">
            <div class="stat-value" v-if="project.id === 1">1</div>
            <div class="stat-value" v-else-if="project.id === 1">18 + {{ project.backers }}</div>
            <div class="stat-value" v-else>{{ project.backers }}</div>
            <div class="stat-title">Socios</div>
          </div>
        </div>
        <div style="width: 100%; justify-content: center; display: flex">{{ formatPercentage(project.pessimistIrr) }}% - {{ formatPercentage(project.optimisticIrr) }}% Retorno Anual</div>
        <div class="button main-button" @click="showInvestmentCalculator = true">Calcula tu inversión</div>
        <div class="social">
          Comparte este proyecto:
          <social-sharing
            class="social-component"
            :url="`https://flagship.mx${$route.path}`"
            :title="project.title"
            description="Ser socio de tu restaurante favorito nunca fue tan fácil"
            quote="Rendimientos anuales entre 12-15% de tu restaurante favorito "
            hashtags="flagship, invierte"
            inline-template>
            <div>
              <network network="email">
                <img class="social-icon" src="/social/email.svg">
              </network>
              <network network="facebook">
                <img class="social-icon" src="/social/facebook.svg">
              </network>
              <network network="twitter">
                <img class="social-icon" src="/social/twitter.svg">
              </network>
              <network network="whatsapp">
                <img class="social-icon" src="/social/whatsapp.svg">
              </network>
            </div>
          </social-sharing>
        </div>
      </div>
    </div>
  </div>
  <div class="section-wrapper" id="project-content">
    <div class="project-main">
      <div class="main-container ">
        <div class="top-menu">
          <div class="menu-element" :class="[ currentTab === 1 ? 'active-element' : '' ]" @click="currentTab = 1">
            Descripción
          </div>
          <div class="menu-element" :class="[ currentTab === 2 ? 'active-element' : '' ]" @click="currentTab = 2">
            Comentarios
          </div>
          <div class="menu-element" :class="[ currentTab === 3 ? 'active-element' : '' ]" @click="currentTab = 3">
            Actualizaciones
          </div>
        </div>
        <div class="about-section" v-if="currentTab === 1">
          <ProjectInfo :content="project.content" :files="project.files" />
        </div>
        <div class="comments-section" v-if="currentTab === 2">
          <div class="new-comment" v-if="loggedIn">
            <textarea class="comment-input" rows="4" placeholder="Escribe aqui tu comentario" v-model="newComment"></textarea>
            <div class="comment-button">
              Max 500 caracteres
              <div class="button" @click="createNewComment">Enviar</div>
            </div>
          </div>
          <div class="comments">
            <div class="comment" v-for="comment in project.comments" :key="comment.id">
              <div class="comment-image">
                <img :src="comment.user.profileImgUrl">
              </div>
              <div class="comment-content">
                <div class="comment-title">
                  {{ comment.user.name  }} {{ comment.user.lastName }}
                  <span>hace 10 minutos</span>
                </div>
                <div class="comment-text">
                  {{ comment.comment }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="updates-section" v-if="currentTab === 3">
          <div class="new-update" v-if="isAdmin">
            <NewUpdate />
          </div>
          <div class="updates">
            <div class="update" v-for="update in project.updates" :key="update.id">
              <div class="update-header">
                <div class="update-date">
                  <div class="update-month">{{ moment(update.created_at).format('MMM') }}</div>
                  <div class="update-day">{{ moment(update.created_at).format('DD') }}</div>
                </div>
                <div class="update-title">{{ update.title }}</div>
                <div class="update-remove" v-if="isAdmin" @click="removeUpdate(update.id)">X</div>
              </div>
              <ProjectInfo :content="update.content" />
            </div>
          </div>
        </div>
      </div>
      <div class="side-container">
        <div class="side-title">¿Quieres ser socio?</div><br>
        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" v-if="project.id === 0">
          <input type="hidden" name="cmd" value="_s-xclick" />
          <input type="hidden" name="hosted_button_id" value="WFMWJ8LZHZEJQ" />
          <input type="image" src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/checkout-logo-large.png" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
          <img alt="" border="0" src="https://www.paypal.com/en_MX/i/scr/pixel.gif" width="1" height="1" />
        </form>
        <div v-if="isAdmin" style="margin-bottom: 30px">
          <div class="button" @click="$router.push(`/admin/projects/${project.id}/investments`)">Administrar</div>
        </div>
        <div v-if="!loggedIn">
          <div class="button" @click="$router.push('/register')">Regístrate</div>
          <div class="button" @click="$router.push({ path: '/login', query: { redirect: $route.path } })">¿Ya tienes cuenta? Inicia sesión</div>
        </div>
        <div v-else-if="loggedIn && project.status === 'progress'">
          <div class="bracket" v-for="bracket in project.brackets" :key="bracket.id" @click="() => {value=bracket.ticketValue; openInvestmentModal()}">
            <div class="bracket-value">Invertir {{ stylizeMoney(bracket.ticketValue) }}</div>
            <div class="bracket-available">Quedan {{ bracket.availableTickets - bracket.backers }} de {{ bracket.availableTickets }}</div>
            <div class="bracket-backers">{{ bracket.backers }} socios</div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '2500000' && project.id === 5">
              <div>Tarjeta Socio Oro</div>
              <div>2 x 1 en destilados siempre</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '5000000' && project.id === 5">
              <div>Tarjeta Socio Platino</div>
              <div>2 x 1 en destilados siempre</div>
              <div>1 postre de cortesía por visita</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '15000000' && project.id === 5">
              <div>Tarjeta Socio Black</div>
              <div>2 x 1 en destilados siempre</div>
              <div>Cuchillo/palillo/copa/vaso tequilero grabado con tu nombre</div>
              <div>20% de descuento en cuenta para socio</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '50000000' && project.id === 5">
              <div>Tarjeta Socio Black</div>
              <div>2 x 1 en destilados siempre</div>
              <div>Cuchillo/palillo/copa/vaso tequilero grabado con tu nombre</div>
              <div>Inscripción a cava personal con placa metálica y nombre completo grabado</div>
              <div>50% de descuento en cuenta para socio</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '1000000' && project.id === 16">
              <div>1 Macaron de cortesía a la semana al consumir cualquier gelato</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '2500000' && project.id === 16">
              <div>Invitación a eventos de degustación de los sabores Amorino</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '5000000' && project.id === 16">
              <div>Degustación exclusiva de sabores de temporada antes del lanzamiento al público</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '15000000' && project.id === 16">
              <div>Descubre el arte del Gelato y aprende a hacer tu propia flor</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '50000000' && project.id === 16">
              <div>Tu nombre grabado en la oficina de la boutique</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '2500000' && project.id === 20">
              <div>2x1 en destilados para el socio + 1 acompañante</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '5000000' && project.id === 20">
              <div>1 Modelada gratis hasta 3 veces a la semana + todos los anteriores</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '10000000' && project.id === 20">
              <div>Cocktel especial socio Fisher´s en tu visita + 5% de descuento en tu consumo + todos los anteriores</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.ticketValue === '50000000' && project.id === 20">
              <div>Se el primero en entrar al llegar a Fisher´s + 10% de descuento + todos los anteriores</div>
            </div>
            <div class="brackets-benefits" v-if="bracket.description">
              {{ bracket.description }}
            </div>
          </div>
          <div class="bracket-custom" :class="{ 'bracket-error': !isValueValid }" v-if="project.status === 'progress'">
            <div class="bracket-value">Personaliza tu inversión</div>
            <input class="bracket-input"
              v-bind:value="stylizeNumber(value)"
              v-on:input="value = $event.target.value.replace(/,/g, '')">
            <div class="bracket-message">Cantidad mínima: $100,000</div>
            <div class="button" :class="{ 'disabled-button': value === '' }" @click="value = value * 100; openInvestmentModal()">Invertir</div>
          </div>
        </div>
        <div v-else-if="project.status === 'soon'">
          Muy pronto podrás invertir en este proyecto. Crea una cuenta para ser de los primeros en
          enterarte y poder invertir.
        </div>
      </div>
    </div>
  </div>
  <Footer/>
  <investment-form v-if="showInvestmentForm" @close="showInvestmentForm = false" />
  <investment-calculator
    v-if="showInvestmentCalculator"
    @close="showInvestmentCalculator = false"
    @invest="showInvestmentCalculator = false; showInvestmentForm = true;"
    :project="project" />
</div>
</template>

<script>
import { createNamespacedHelpers, mapMutations } from 'vuex';
import Dinero from 'dinero.js';
import moment from 'moment';
import formatMixin from '@/mixins/formatMixin';
import socialSharing from 'vue-social-sharing';
import gallery from '@/components/Gallery.vue';
import progress from '@/components/Progress.vue';
import Footer from '@/components/Footer.vue';
import investmentCalculator from '@/components/InvestmentCalculator.vue';
import investmentForm from '@/components/Investment.vue';
// import PremiumCard from '@/components/PremiumCard.vue';
import ProjectInfo from '@/components/ProjectInfo.vue';
import NewUpdate from '@/components/NewUpdate.vue';
import GuestModal from '@/components/GuestModal.vue';

const { mapState, mapActions } = createNamespacedHelpers('project');
export default {
  name: 'Project',
  data() {
    return {
      value: '',
      key: 'AIzaSyCBg-FHk2T4HsTysFJJyS5cUrfVjOnMXgI',
      sentInvestment: false,
      currentTab: 1,
      newComment: '',
      showInvestmentForm: false,
      showInvestmentCalculator: false,
      moment,
      isGuestModalOpen: true,
    };
  },
  mixins: [formatMixin],
  components: {
    gallery,
    socialSharing,
    'progress-chart': progress,
    Footer,
    investmentCalculator,
    investmentForm,
    // PremiumCard,
    ProjectInfo,
    NewUpdate,
    GuestModal,
  },
  computed: {
    showGuestModal() {
      return !this.loggedIn && this.project.status === 'soon' && this.isGuestModalOpen;
    },
    completed() {
      return (this.project.raised / this.project.target) * 100;
    },
    loggedIn() {
      return this.$store.state.user.user;
    },
    isAdmin() {
      return this.$store.state.user.user && this.$store.state.user.user.isAdmin;
    },
    isValueValid() {
      if (this.value === '' || (this.value && parseFloat(this.value) >= 100000)) {
        return true;
      }
      return false;
    },
    showPremiumScreen() {
      if (this.project.isPremium && (!this.loggedIn || !this.$store.state.user.user.isLocked)) {
        return true;
      }
      return false;
    },
    ...mapState([
      'project',
    ]),
  },
  methods: {
    stylizeNumber(number) {
      if (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return null;
    },
    stylizeMoney(number) {
      const result = Dinero({ amount: parseInt(number, 10) });
      return result.toFormat('$0,0');
    },
    openInvestmentModal() {
      this.$router.push(`/project/${this.project.id}/invest?investment=${this.value}`);
    },
    async createNewComment() {
      await this.postComment({
        projectId: this.project.id,
        data: {
          comment: this.newComment,
        },
      });
      this.newComment = '';
    },
    async removeUpdate(updateId) {
      await this.deleteUpdate({
        updateId,
        projectId: this.project.id,
      });
    },
    ...mapMutations('investment', [
      'setCurrentProject',
      'setInvestment',
    ]),
    ...mapActions([
      'getProject',
      'postInvestment',
      'postComment',
      'deleteUpdate',
    ]),
  },
  async mounted() {
    const { projectId } = this.$route.params;
    await this.getProject(projectId);
    const hashRoute = this.$route.hash;
    const content = document.getElementById('project-content');
    switch (hashRoute) {
      case '#comments':
        this.currentTab = 2;
        content.scrollIntoView();
        break;
      case '#updates':
        this.currentTab = 3;
        content.scrollIntoView();
        break;
      case '#calculator':
        this.showInvestmentCalculator = true;
        break;
      default:
        this.currentTab = 1;
        break;
    }
  },
};
</script>

<style scoped lang="scss">
.project-background {
  // padding: 70px 0 0 0;
  background-color: white;
  font-family: 'Inter', sans-serif;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header-image {
  height: 150px;
  min-height: 150px;
  min-width: 1100px;
  width: 1100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  margin-top: 110px;
}
.section-wrapper {
  width: 1100px;
  padding: 50px 0;
}
.project-type {
  font-size: 15px;
  text-transform: uppercase;
  color: #2c70c1;
  margin-bottom: 12px;
}
.project-name {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 6px;
}
.project-location {
  font-size: 18px;
}
.project-info {
  width: 100%;
  display: flex;
}
.info-wrapper {
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
}
.info-container {
  width: 1100px;
  padding: 35px 0;
  display: flex;
  justify-content: space-between;
}
.project-main {
  display: flex;
  justify-content: space-between;
}
.main-container {
  width: 68%;
  max-width: 68%;
}
.side-container {
  width: 28%;
  max-width: 28%;
}
.bracket {
  border-radius: 8px;
  border: 1px solid #DCDEDD;
  margin-bottom: 20px;
  padding: 16px;
  cursor: pointer;

  &:hover {
    border: 1px solid #2c70c1;
  }
}
.bracket-value {
  font-size: 18px;
  margin-bottom: 16px;
  color: #202124;
}
.bracket-custom {
  border-radius: 8px;
  border: 1px solid #DCDEDD;
  margin-bottom: 20px;
  padding: 16px;
}
.bracket-backers {
  color: #202124;
  margin-top: 4px;
  font-size: 16px;
}
.bracket-available {
  font-size: 14px;
  color: #5f6368;
}
.bracket-input {
  border: 1px solid #DCDEDD;
  width: 100%;
  font-size: 16px;
  padding: 8px;
}
.bracket-message {
  font-size: 14px;
  color: #5f6368;
  margin-top: 4px;
  text-align: center;
}
.bracket-error {
  .bracket-input {
    border: 1px solid red !important;
  }
  .bracket-message {
    color: red !important;
  }
  .button {
    filter:opacity(30%);
  }
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 0;
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}
.social {
  margin-top: 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  align-items: center;
}
/deep/ .social-icon {
  max-width: 24px;
  height: auto;
  margin-left: 12px;
  cursor: pointer;
}
.social-component {
  width: 48%;
}
.progress-wrapper {
  margin: 10px 0 20px 0;
}
.side-title {
  font-size: 20px;
}
.stats {
  display: flex;
  margin-bottom: 20px;
}
.stat-money {
  width: 70%;
}
.stat {
  width: 30%;
}
.stat-title {
  font-size: 16px;
  color: #5f6368;
}
.stat-value {
  font-size: 20px;
  color: #202124;
  margin-bottom: 4px;
}
.main-button {
  margin-top: 20px;
}
.image {
  width: 130px !important;
  height: auto;
  margin-top: 10px;
}
.about-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  font-size: 16px;

  .title {
    font-size: 28px;
    font-weight: bold;
    margin: 0 0 16px 0;
  }
  .subtitle {
    font-size: 18px;
    margin: 14px 0 12px 0;
    color: #202124;
  }
  p {
    line-height: 1.5;
    text-align: justify;
    & + .title {
      margin-top: 32px;
    }
  }
  br {
    margin-bottom: 12px;
  }
  img {
    width: 100%;
    height: auto;
    margin: 10px 0;

    & + .title {
      margin-top: 32px;
    }
  }
}
.time-section {
  margin-top: 15px;
}
.time {
  font-size: 18px;
  color: #202124;
  margin-bottom: 4px;

  span {
    font-size: 32px;
  }
}
.top-menu {
  display: flex;
  margin-bottom: 20px;
}
.menu-element {
  cursor: pointer;
  padding: 0 1px 14px 1px;
  color: #5f6368;
  margin-right: 30px;
}
.active-element {
  border-bottom: 2px solid #2c70c1;
  color: black;
}
.comments-section {
  display: flex;
  flex-direction: column;
}
.new-comment {
  display: flex;
  flex-direction: column;
  background-color: #f6f6f6;
  padding: 24px;
  border-radius: 5px;
}
.comment-input {
  resize: none;
  border: none;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  padding: 16px;
  box-sizing: border-box;
}
.comment-button {
  display: flex;
  color: #5f6368;
  justify-content: space-between;
  align-items: baseline;

  .button {
    width: 150px;
  }
}
.comments {
  width: 100%;
  display: flex;
  padding: 30px 0 0 0;
  flex-direction: column;
}
.comment {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.comment-image {
  width: 6%;
  max-width: 6%;
  min-width: 6%;

  img {
    border-radius: 100%;
    width: 100%;
  }
}
.comment-content {
  width: 92%;
  min-width: 92%;
  max-width: 92%;
  display: flex;
  flex-direction: column;
}
.comment-title {
  margin-bottom: 8px;
  font-weight: 500;
  span {
    margin-left: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #5f6368;
  }
}
.comment-text {
  line-height: 20px;
  text-align: justify;
}
.brackets-benefits {
  margin-top: 15px;
  border-top: 1px solid #DCDEDD;
  padding-top: 12px;
  font-size: 15px;
  line-height: 16px;

  div {
    padding: 4px 0;
  }
}
.new-update {
  display: flex;
  flex-direction: column;
  background-color: #f6f6f6;
  padding: 24px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.update {
  width: 100%;
  padding: 20px 10px;
  border-top: 1px solid #DCDEDD;
  border-bottom: 1px solid #DCDEDD;
}
.update-header {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.update-date {
  display: flex;
  flex-direction: column;
  min-width: 60px;
}
.update-month {
  border-radius: 10px 10px 0 0;
  background-color: darken($color: #3479e9, $amount: 10);
  color: white;
  text-align: center;
  padding: 4px 0;
  font-size: 12px
}
.update-day {
  border-radius: 0 0 10px 10px;
  background-color: #3479e9;
  color: white;
  text-align: center;
  font-size: 24px;
  padding: 8px 0;
}
.update-title {
  margin-left: 18px;
  font-size: 2rem;
  font-weight: bold;
}
.update-remove {
  align-self: flex-start;
  color: red;
  cursor: pointer;
}
@media only screen and (max-width: 1100px) {
  .info-container {
    width: 92%;
  }
  .section-wrapper {
    width: 92%;
  }
}
@media only screen and (max-width: 800px) {
  .info-container {
    flex-direction: column;
  }
  .project-main {
    flex-direction: column;
  }
  .main-container {
    width: 100%;
    max-width: 100%;
    order: 2;
  }
  .side-container {
    width: 100%;
    max-width: 100%;
    order: 1;
    margin-bottom: 20px;
  }
  .top-menu {
    margin-top: 30px;
  }
}
</style>
